export default __webpack_public_path__ + "static/media/203.ea761446.jpg";